import React from "react";
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  Link,
} from "@mui/material";
import { errorTextFieldStyles } from "../../styles/globalStyles";

const LoginBox = ({
  formData,
  handleChange,
  handleSubmit,
  emailError,
  passwordError,
  onForgotPasswordClick,
}) => (
  <Box
    sx={{
      maxWidth: 400,
      width: "100%",
      mx: "auto",
      textAlign: "center",
      mt: 10,
      position: "relative",
      zIndex: 2, // 👈 ensures above background blobs
    }}
  >
    <Paper
      elevation={4}
      sx={{
        p: 4,
        borderRadius: 3,
        backgroundColor: "#ffffff",
      }}
    >
      <Typography variant="h5" fontWeight={600} mb={2}>
        Log In
      </Typography>

      <Box component="form" onSubmit={handleSubmit} noValidate>
        <TextField
          fullWidth
          label="Email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          margin="normal"
          type="email"
          required
          error={!!emailError}
          helperText={emailError}
          sx={emailError ? errorTextFieldStyles : {}}
        />

        <TextField
          fullWidth
          label="Password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          margin="normal"
          type="password"
          required
          error={!!passwordError}
          helperText={passwordError}
          sx={passwordError ? errorTextFieldStyles : {}}
        />

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              mt: 3,
              borderRadius: "25px",
              py: 1.25,
              px: 3,
              fontWeight: 600,
              textTransform: "none",
            }}
          >
            Log In
          </Button>
        </Box>

        <Typography align="center" mt={2}>
          <Link
            component="button"
            onClick={onForgotPasswordClick}
            underline="hover"
            sx={{ fontSize: "0.9rem" }}
          >
            Forgot your password?
          </Link>
        </Typography>
      </Box>
    </Paper>
  </Box>
);

export default LoginBox;
